import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, signal, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { COUNTRY_CODE, ENDPOINTS } from '@core/enums';
import { ICountryMask, ICountryRules, IResponseModel } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
export class CountryRulesService implements ICountryRules {
  private http = inject(HttpClient);

  // TODO: Deveria ter um outro service para controlar o estado do componente, e não o próprio service que busca as máscaras
  cityCodeDisabled = [COUNTRY_CODE.CHILE, COUNTRY_CODE.PERU, COUNTRY_CODE.ECUADOR];
  disabledAllFieldsPhone = signal<boolean>(false);
  isDisabledCityCode = signal<boolean>(false);

  active = signal<boolean>(false);
  masksSignal = signal<ICountryMask | null>(null);

  constructor(
    @Inject('url') private readonly url: string,
  ) { }

  async loadMasks(country: string): Promise<void> {
    const endpoint = `${this.url}${ENDPOINTS.COUNTRY_MASKS}/${country}`;
    this.isDisabledCityCode.set(this.isDisabledCityCodeByCountry(country));

    try {
      let { response } = await firstValueFrom(this.http.get<IResponseModel<ICountryMask>>(endpoint));

      const { useMaskCityCodeToPhone } = response;
      if (this.isActive(useMaskCityCodeToPhone)) {
        response = this.formatMask(response);

        this.masksSignal.set(response);
        this.active.set(true);
      }

    } catch (error) {
      console.error('Error loading masks:', error);
    }
  }

  /*
  * Check if is active
  * @param active string
  * @returns boolean
  * */
  private isActive(active: string): boolean {
    return active === 'true';
  }

  /*
  * Format mask
  * @param masks ICountryMask
  * @returns ICountryMask
  * */
  private formatMask(masks: ICountryMask): ICountryMask {
    const { maskPhone, maskCityCode } = masks;
    return {
      ...masks,
      maskPhone: this.replaceMaskTypeNumber(maskPhone),
      maskCityCode: this.replaceMaskTypeNumber(maskCityCode),
    };
  }

  /*
  * Replace mask type number - 9 to 0 and, ; to || and - to ''
  * @param mask string
  * @returns string
  * */
  private replaceMaskTypeNumber = (mask: string): string => mask?.replaceAll('9', '0').replaceAll(';', '||').replaceAll('-', '');

  private isDisabledCityCodeByCountry = (country: string): boolean => this.cityCodeDisabled.includes(country as COUNTRY_CODE);
}
